
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const TestGridPage = lazy(() => import('../pages/test-grid/page'));
const LeistungenPage = lazy(() => import('../pages/leistungen/page'));
const WebdesignPage = lazy(() => import('../pages/leistungen/webdesign/page'));
const SoftwareentwicklungPage = lazy(() => import('../pages/leistungen/softwareentwicklung/page'));
const KIChatbotsPage = lazy(() => import('../pages/leistungen/ki-chatbots/page'));
const ReputationListingPage = lazy(() => import('../pages/leistungen/reputation-listing/page'));
const FoerderungPage = lazy(() => import('../pages/leistungen/foerderung/page'));
const KIAutomatisierungPage = lazy(() => import('../pages/leistungen/ki-automatisierung/page'));
const BusinessIntelligencePage = lazy(() => import('../pages/leistungen/business-intelligence/page'));
const DigitaleTransformationPage = lazy(() => import('../pages/leistungen/digitale-transformation/page'));
const UeberUnsPage = lazy(() => import('../pages/ueber-uns/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const KIStrategiePage = lazy(() => import('../pages/blog/ki-strategie-entwicklung/page'));
const ChatbotImplementierungPage = lazy(() => import('../pages/blog/chatbot-implementierung/page'));
const DigitaleTransformationErfolgsfaktorenPage = lazy(() => import('../pages/blog/digitale-transformation-erfolgsfaktoren/page'));
const WebdesignTrends2026Page = lazy(() => import('../pages/blog/webdesign-trends-2026/page'));
const NachhaltigeDigitaleTransformationPage = lazy(() => import('../pages/blog/nachhaltige-digitale-transformation/page'));
const KIStrategieDeutschland2026Page = lazy(() => import('../pages/blog/ki-strategie-deutschland-2026/page'));
const DigitalisierungDeutschland2026Page = lazy(() => import('../pages/blog/digitalisierung-deutschland-2026/page'));
const KIImplementierungsGuideAnimationenPage = lazy(() => import('../pages/blog/ki-implementierungs-guide-mit-animationen/page'));
const AutonomeKIAgentenMittelstandPage = lazy(() => import('../pages/blog/autonome-ki-agenten-mittelstand-2026/page'));
const BFSGBarrierefreieWebsitePage = lazy(() => import('../pages/blog/bfsg-barrierefreie-website-pflicht-2026/page'));
const TopFoerderprogramme2026Page = lazy(() => import('../pages/blog/top-foerderprogramme-digitalisierung-ki-2026/page'));
const DSGVOundKIChatbotsPage = lazy(() => import('../pages/blog/dsgvo-ki-chatbots-rag-systeme-mittelstand/page'));
const KISicherheitCloudVsOnPremisePage = lazy(() => import('../pages/blog/ki-sicherheit-cloud-vs-on-premise-llm-mittelstand/page'));
const StandorteHubPage = lazy(() => import('../pages/standorte/page'));
const CityLandingPage = lazy(() => import('../pages/standorte/city/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const AGBPage = lazy(() => import('../pages/agb/page'));
const NotFoundPage = lazy(() => import('../pages/not-found/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/test-grid',
    element: <TestGridPage />,
  },
  {
    path: '/leistungen',
    element: <LeistungenPage />,
  },
  {
    path: '/leistungen/webdesign',
    element: <WebdesignPage />,
  },
  {
    path: '/leistungen/softwareentwicklung',
    element: <SoftwareentwicklungPage />,
  },
  {
    path: '/leistungen/ki-chatbots',
    element: <KIChatbotsPage />,
  },
  {
    path: '/leistungen/reputation-listing',
    element: <ReputationListingPage />,
  },
  {
    path: '/leistungen/foerderung',
    element: <FoerderungPage />,
  },
  {
    path: '/leistungen/ki-automatisierung',
    element: <KIAutomatisierungPage />,
  },
  {
    path: '/leistungen/business-intelligence',
    element: <BusinessIntelligencePage />,
  },
  {
    path: '/leistungen/digitale-transformation',
    element: <DigitaleTransformationPage />,
  },
  {
    path: '/ueber-uns',
    element: <UeberUnsPage />,
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/ki-strategie-entwicklung',
    element: <KIStrategiePage />,
  },
  {
    path: '/blog/chatbot-implementierung',
    element: <ChatbotImplementierungPage />,
  },
  {
    path: '/blog/digitale-transformation-erfolgsfaktoren',
    element: <DigitaleTransformationErfolgsfaktorenPage />,
  },
  {
    path: '/blog/webdesign-trends-2026',
    element: <WebdesignTrends2026Page />,
  },
  {
    path: '/blog/nachhaltige-digitale-transformation',
    element: <NachhaltigeDigitaleTransformationPage />,
  },
  {
    path: '/blog/ki-strategie-deutschland-2026',
    element: <KIStrategieDeutschland2026Page />,
  },
  {
    path: '/blog/digitalisierung-deutschland-2026',
    element: <DigitalisierungDeutschland2026Page />,
  },
  {
    path: '/blog/ki-implementierungs-guide-mit-animationen',
    element: <KIImplementierungsGuideAnimationenPage />,
  },
  {
    path: '/blog/autonome-ki-agenten-mittelstand-2026',
    element: <AutonomeKIAgentenMittelstandPage />,
  },
  {
    path: '/blog/bfsg-barrierefreie-website-pflicht-2026',
    element: <BFSGBarrierefreieWebsitePage />,
  },
  {
    path: '/blog/top-foerderprogramme-digitalisierung-ki-2026',
    element: <TopFoerderprogramme2026Page />,
  },
  {
    path: '/blog/dsgvo-ki-chatbots-rag-systeme-mittelstand',
    element: <DSGVOundKIChatbotsPage />,
  },
  {
    path: '/blog/ki-sicherheit-cloud-vs-on-premise-llm-mittelstand',
    element: <KISicherheitCloudVsOnPremisePage />,
  },
  {
    path: '/standorte',
    element: <StandorteHubPage />,
  },
  {
    path: '/standorte/:citySlug',
    element: <CityLandingPage />,
  },
  {
    path: '/standorte/:citySlug/:serviceSlug',
    element: <CityLandingPage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/agb',
    element: <AGBPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
